<template>
  <div>
    <Home />
  </div>
</template>

<script>
import Home from "./pages/home";

export default {
  name: "app",
  components: {
    Home
  }
};
</script>

<style lang="scss">
html {
  background: #ffffff;
  
  @media screen and (max-width: 800px) {
      box-shadow: inset 0 0 0 4vw #ffffff;
  }
}

body {
  margin: 0;
  background: #f4f4f4;
  box-shadow: inset 0 0 0 32px #ffffff;
}
</style>
